<template>
  <div class="tabs border-t border-gray-300">
    <button
      v-for="(tab, idx) in tabs"
      :key="tab.name"
      :class="[
        'tab-button',
        { active: parseInt(currentTabIdx) === parseInt(idx) }
      ]"
      @click="currentTabIdx = idx"
    >
      {{ tab.label }}
    </button>

    <keep-alive>
      <component :is="tabs[currentTabIdx].component" class="tab"></component>
    </keep-alive>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Role from "@/constants/Role";
import { hasValidRole } from "@/helpers/role-helper";

export default {
  props: ["tabs"],
  data() {
    return {
      currentTabIdx: 0
    };
  },
  created() {
    this.getEventsByQuery();
  },
  computed: {
    ...mapGetters("user", ["role", "info"])
  },
  methods: {
    getEventsByQuery() {
      const query = this.$route.query;
      if (!query.tabActive) return;
      this.currentTabIdx = query.tabActive;
      if (hasValidRole(this.role, Role.Student)) {
        this.$router.replace({ query: {} });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../node_modules/vue-material/dist/theme/engine";

.tab-button {
  @apply py-2 px-4;
  @apply text-gray-500 font-medium;
  @apply cursor-pointer;
  @apply outline-none;

  font-size: 1rem;

  &.active {
    border-top: 2px solid md-get-palette-color(purple, 500);
  }
}
</style>
